<template>
  <div class="message-container">
    <ots-main-title :mainTopBtn="mainTopBtnList"></ots-main-title>
    <ots-refer
      :selectList="selectList"
      :request-form="selectForm"
      @search="getResult"
    />
    <ots-table-group-new
      :tableHeader="tableHeader"
      :tableData="tableData"
      :pagination="pagination"
      @changeNum="changeSize"
      @changePage="changePage"
    ></ots-table-group-new>
  </div>
</template>

<script>
import { getAskListFn, exportAskListFn } from '@/http/modules/applySet/message'
import { getQueryAllSchool } from '@/http/modules/school'
import { getQueryAllStation } from '@/http/modules/station'
export default {
  name: 'askExamManage',
  data () {
    return {
      mainTopBtnList: [
        {
          title: '导出',
          fn: this.exportAskRecord
        }
      ],
      selectList: [
        {
          title: "考试批次",
          type: "select",
          requestKey: "planId",
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: "是否参加",
          type: "select",
          requestKey: "joinExamFlag",
          label: "key",
          value: "value",
          data: [
            {
              key: "全部",
              value: "",
            },
            {
              key: "参加",
              value: "1",
            },
            {
              key: "不参加",
              value: "0",
            },
            {
              key: "未确认",
              value: "2",
            },
          ],
        },
        {
          title: "学校",
          type: "select",
          requestKey: "schoolId",
          label: "key",
          value: "value",
          data: [],
        },
        {
          title: "教学点",
          type: "select",
          isSearch: true,
          multiple: true,
          requestKey: "stationId",
          label: "key",
          value: "value",
          data: [],
        },
        {
          title: "关键词",
          type: "input",
          requestKey: "searchKey",
          placeholder: "姓名/证件号",
        },
        {
          title: "手机号",
          type: "input",
          requestKey: "phone",
          placeholder: "请输入",
        },
      ],
      selectForm: {
        planId: '',
        joinExamFlag : '',
        schoolId: "",
        stationId: [''],
        searchKey:'',
        phone: "",
        page: 1,
        size: 10,
      },
      tableHeader: [
        {
          title: "考试批次",
          prop: "planName"
        },
        {
          title: "学校",
          prop: "schoolName",
        },
        {
          title: '教学点',
          prop: 'stationName'
        },
        {
          title: "姓名",
          prop: "realName",
        },
        {
          title: "证件号",
          prop: "cardNo",
        },
        {
          title: "手机号",
          prop: "phone",
        },
        {
          title: "是否参加",
          prop: "joinExamFlag",
        },
        {
          title: "备注",
          prop: "reasonDesc",
          type: "textTooltip",
          disableFn: function(scope) {
            return scope.row.reasonDescOriginal ? false : true;
          },
          data: function(scope) {
            return `<div style="line-height:25px; padding:1px 5px 1px;">${scope.row.reasonDescOriginal}</div>`;
          },
        },
        {
          title: "确认时间",
          prop: "createDate",
          width: "110"
        },
      ],
      tableData: [],
      pagination: {
        total: 0,
      },
    }
  },
  mounted() {
    this.initData();
    /**************************
     * @this : 获取学校列表 (启用)
     **************************/
    getQueryAllSchool({state: 1}).then(res => {
      if (res.code) {
        for(let i=0;i<this.selectList.length;i++){
          if(this.selectList[i].requestKey == "schoolId"){
            this.selectList[i].data.push({value: '', key: '全部'});
            res.data.map(e => {
              let obj = {};
              obj.value = e.id;
              obj.key = e.name;
              this.selectList[i].data.push(obj);
            });
          }
        }
      }
    });

    /**************************
     * @this : 获取教学点列表(启用)
     **************************/
    getQueryAllStation({state: 1}).then(res => {
      if (res.code){
        for(let i=0;i<this.selectList.length;i++){
          if(this.selectList[i].requestKey == "stationId"){
            this.selectList[i].data.push({value: '', key: '全部'});
            res.data.map(e => {
              let obj = {};
              obj.value = e.id;
              obj.key = e.name;
              this.selectList[i].data.push(obj);
            })
          }
        }
      }
    });
  },

  methods: {
    /**************************
     * @this : 获取表单提交信息
     **************************/
    getResult() {
      this.selectForm.page = 1
      this.getTableList();
    },

    /**************************
     * @this : 导出按钮绑定事件
     **************************/
    exportAskRecord() {
      let params = {...this.selectForm};
      if (typeof(params.stationId) == 'object') {
        params.stationId = params.stationId.join(',');
      }
      delete params.page;
      delete params.size;
      exportAskListFn(params).then(res => {
        window.open(res.data);
      })
    },

    /**************************
     * @this : 获取考试批次id
     **************************/
    initData() {
      this.mixin_getSelectPlan().then((data) => {
        let dataList = [
        //   {
        //     id: '',
        //     name: '全部'
        //   },
          ...data,
        ]
        this.selectForm.planId = dataList[0].id;
        this.$set(this.selectList[0], "data", dataList);
        this.getTableList();
      });
    },

    /**************************
     * @this : 配置调用接口参数
     **************************/
    dealParamsWithArray(obj) {
      let params = { ...obj }
      for (let item in params) {
        if (Array.isArray(params[item])){
          delete params[item]
        }
      }
      return params
    },

    /**************************
     * @this : 调用接口,获取表格数据
     **************************/
    getTableList() {
      let params = this.dealParamsWithArray(this.selectForm)

      if (typeof(this.selectForm.stationId) == 'object') {
        params.stationId = this.selectForm.stationId.join(',');
      }

      getAskListFn(params).then(res => {
        this.tableData = res.data.records.map(item => {
          return {
            ...item,
            reasonDesc: item.reasonDesc && item.reasonDesc.length > 10 ? item.reasonDesc.substring(0,10)+'...' : item.reasonDesc,
            reasonDescOriginal: item.reasonDesc ? item.reasonDesc.replace(/\n/g, '<br/>') : '',
          }
        })
        this.pagination.total = res.data.total
      })
    },

    /**************************
     * page 分页......
     **************************/
    changeSize(num) {
      this.selectForm.size = num;
      this.getTableList();
    },
    changePage(p) {
      this.selectForm.page = p;
      this.getTableList();
    },
  }
}
</script>

<style lang="less" scoped>
.mainCon {
  margin-top: 16px;
  // padding: 24px;
  background: #fff;
  border-radius: 8px;
}
.resendMessage{
  font-size:20px;
  font-weight:700;
  color:#303133;
}
</style>